import React from 'react';
import useInView from './useInView';
import TypewriterTitle from './TypewriterTitle';

export default function ServiceCivil() {
  const [heroRef, heroIn] = useInView();
  const [contentRef, contentIn] = useInView();

  return (
    <div style={{ paddingTop: 'var(--nav-h)', overflowX: 'hidden', width: '100%', maxWidth: '100%' }}>
      {/* Hero */}
      <div style={{
        height: '60vh', minHeight: 400, position: 'relative',
        display: 'flex', alignItems: 'center', overflow: 'hidden',
      }}>
        <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1800&q=85&fit=crop"
          alt="Civil Construction" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(105deg, rgba(10,22,40,0.85) 0%, rgba(10,22,40,0.4) 100%)' }} />
        <div className="section-wrap" style={{ position: 'relative', zIndex: 2 }}>
          <div className="section-label light">What We Do</div>
          <TypewriterTitle lines={['Civil & Building', 'Construction']} />
          <p style={{ fontSize: '1.1rem', color: 'rgba(255,255,255,0.75)', maxWidth: 560, marginTop: '1.5rem', lineHeight: 1.75 }}>
            Full-spectrum civil engineering and building construction delivered with precision across Nigeria.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <section style={{ padding: '6rem 0', background: 'white' }}>
        <div className="section-wrap">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '3rem', alignItems: 'start' }}>
            <div ref={contentRef} style={{ opacity: contentIn ? 1 : 0, transform: contentIn ? 'none' : 'translateY(30px)', transition: 'all 0.8s ease' }}>
              <div className="section-label">Our Expertise</div>
              <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>Building <span>Nigeria's</span> Future</h2>
              <p style={{ fontSize: '1.05rem', lineHeight: 1.85, color: '#2a3a5c', marginBottom: '1.2rem' }}>
                Rigomich Integrated Company Limited has built a strong reputation in civil and building construction across Nigeria. From road networks to commercial complexes, we deliver projects that stand the test of time.
              </p>
              <p style={{ fontSize: '1rem', lineHeight: 1.85, color: '#6b7fa8', marginBottom: '2rem' }}>
                Our team of 30+ experienced engineers and construction professionals bring deep expertise to every project — ensuring quality, safety, and on-time delivery for government, corporate, and private clients.
              </p>
              <a href="/#contact" className="btn-primary"><span>Request a Quote</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </a>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '1rem' }}>
              {[
                { img: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=500&q=80&fit=crop', label: 'Road Construction' },
                { img: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=500&q=80&fit=crop', label: 'Commercial Buildings' },
                { img: 'https://images.unsplash.com/photo-1590725121839-892b458a74fe?w=500&q=80&fit=crop', label: 'Bridge Works' },
                { img: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=500&q=80&fit=crop', label: 'Infrastructure' },
              ].map((item, i) => (
                <div key={i} style={{ position: 'relative', overflow: 'hidden', aspectRatio: '1' }}>
                  <img src={item.img} alt={item.label} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.06)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '0.8rem', background: 'linear-gradient(to top, rgba(10,22,40,0.9), transparent)' }}>
                    <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.75rem', fontWeight: 700, color: 'white', letterSpacing: '0.1em', textTransform: 'uppercase' }}>{item.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section style={{ padding: '5rem 0', background: '#0a1f5c' }}>
        <div className="section-wrap">
          <div className="section-label light" style={{ marginBottom: '1rem' }}>What We Offer</div>
          <h2 className="section-title light" style={{ marginBottom: '3rem' }}>Our <span>Services</span></h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '2px' }}>
            {[
              { title: 'Road & Highway Construction', desc: 'Design and construction of roads, highways, and urban street networks across Nigeria.' },
              { title: 'Bridge Construction', desc: 'Structural design and construction of bridges and elevated infrastructure.' },
              { title: 'Stadium & Public Infrastructure', desc: 'Large-scale public facilities including stadiums, markets, and civic centers.' },
              { title: 'Residential Buildings', desc: 'Quality residential construction from single units to large housing estates.' },
              { title: 'Commercial Complexes', desc: 'Office buildings, shopping centers, and mixed-use commercial developments.' },
              { title: 'Industrial Facilities', desc: 'Factories, warehouses, and industrial infrastructure built to spec.' },
            ].map((s, i) => (
              <div key={i} style={{ background: 'rgba(255,255,255,0.05)', padding: '2rem', borderBottom: '3px solid transparent', transition: 'all 0.3s', cursor: 'default' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(26,79,156,0.3)'; e.currentTarget.style.borderBottomColor = '#7aaef0'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.borderBottomColor = 'transparent'; }}>
                <div style={{ width: 8, height: 8, background: '#7aaef0', marginBottom: '1rem' }} />
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '1rem', color: 'white', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.6rem' }}>{s.title}</div>
                <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.7 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '5rem 0', background: 'var(--off-white)', textAlign: 'center' }}>
        <div className="section-wrap">
          <h2 className="section-title" style={{ marginBottom: '1rem' }}>Ready to Start Your <span>Project?</span></h2>
          <p style={{ fontSize: '1.05rem', color: '#6b7fa8', marginBottom: '2rem' }}>Contact us today for a free consultation and project quote.</p>
          <a href="/#contact" className="btn-primary"><span>Get In Touch</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </a>
        </div>
      </section>
    </div>
  );
}
